module.exports = __webpack_public_path__ + "static/media/neko-old-theme.aa1aedcc.wav";